// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"04ca8eb7","455":"6465d2fa","977":"9a3c7d35"}[chunkId] + ".chunk.js";
};